module.exports = __webpack_public_path__ + "img/room-1.0eaae527.jpg";